import { ExpandableText } from "src/components/common/expandable-text";
import { SimpleRichText } from "src/components/common/rich-text/simple-rich-text";
import { IFeedCardRichTextBody } from "src/components/feed-card/types/content";

export interface IFeedCardRichText extends IFeedCardRichTextBody {}

export const FeedCardRichText = ({ text, isCollapsible }: IFeedCardRichText) =>
    isCollapsible ? <ExpandableText text={text} formattingType="umbracoHtml" /> : <SimpleRichText text={text} />;
